import Loader from "./Loader";
import FullLoader from "./FullLoader";
import Line from "./skeleton/Line";
import Rectangle from "./skeleton/Rectangle";
import Circle from "./skeleton/Circle";

export { FullLoader, Loader, Line, Rectangle, Circle };
